import 'waypoints/lib/jquery.waypoints';
import { CountUp } from 'countup.js/dist/countUp.min';

$(document).ready(function() {
  const numbers = ['investigadores', 'doctores', 'publicaciones'];

  new Waypoint({
    element: $('#investigadores'),
    offset: '100%',
    handler: (direction) => {
      numbers.forEach(number => {
        makeACountUp(number);
      });
    }
  });
});

function makeACountUp(id){
  const quantity = $(`#${id}`).data('cant');
  return new CountUp(id, quantity).start();
}





// WEBPACK FOOTER //
// ./assets/js/components/countup-impulsa.js